import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ATTSCHEDULEDETAIL,
  DELETE_ATTSCHEDULEDETAIL,
  UPDATE_ATTSCHEDULEDETAIL,
  ADD_NEW_ATTSCHEDULEDETAIL,
} from "./actionType";

import {
  getAttScheduleDetailSuccess,
  getAttScheduleDetailFail,
  deleteAttScheduleDetailSuccess,
  deleteAttScheduleDetailFail,
  updateAttScheduleDetailSuccess,
  updateAttScheduleDetailFail,
  addAttScheduleDetailSuccess,
  addAttScheduleDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAttScheduleDetailApi,
  getAttScheduleDetailApi,
  updateAttScheduleDetailApi,
  deleteAttScheduleDetailApi,
  addNewAttScheduleDetailApi
} from "../../helpers/backend_helper";

function* getAttScheduleDetail({ payload: attScheduleDetail }) {
  try {
    const response = yield call(getAttScheduleDetailApi, attScheduleDetail);
    yield put(getAttScheduleDetailSuccess(GET_ATTSCHEDULEDETAIL, response.data));
  } catch (error) {
    yield put(getAttScheduleDetailFail(GET_ATTSCHEDULEDETAIL, error));
  }
}

function* onUpdateAttScheduleDetail({ payload: attScheduleDetail }) {
  try {
    if (attScheduleDetail.setApprove) {
      const response = yield call(approveAttScheduleDetailApi, attScheduleDetail);
      yield put(updateAttScheduleDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAttScheduleDetailApi, attScheduleDetail);
      yield put(updateAttScheduleDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAttScheduleDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAttScheduleDetail({ payload: attScheduleDetail }) {
  try {
    const response = yield call(deleteAttScheduleDetailApi, attScheduleDetail);
    yield put(deleteAttScheduleDetailSuccess({ attScheduleDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAttScheduleDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAttScheduleDetail({ payload: attScheduleDetail }) {
  try {
    const response = yield call(addNewAttScheduleDetailApi, attScheduleDetail);
    yield put(addAttScheduleDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAttScheduleDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAttScheduleDetail() {
  yield takeEvery(GET_ATTSCHEDULEDETAIL, getAttScheduleDetail);
}

export function* watchUpdateAttScheduleDetail() {
  yield takeEvery(UPDATE_ATTSCHEDULEDETAIL, onUpdateAttScheduleDetail);
}

export function* watchDeleteAttScheduleDetail() {
  yield takeEvery(DELETE_ATTSCHEDULEDETAIL, onDeleteAttScheduleDetail);
}

export function* watchAddNewAttScheduleDetail() {
  yield takeEvery(ADD_NEW_ATTSCHEDULEDETAIL, onAddNewAttScheduleDetail);
}

function* attScheduleDetailSaga() {
  yield all([
    fork(watchGetAttScheduleDetail),
    fork(watchDeleteAttScheduleDetail),
    fork(watchUpdateAttScheduleDetail),
    fork(watchAddNewAttScheduleDetail)
  ]);
}

export default attScheduleDetailSaga;
